import { useContext } from 'react';
import { AlertContext } from '../context/alert';

export const useAlert = () => useContext(AlertContext);
